import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import InlineLoader from 'components/_core/InlineLoader';
import Message from 'components/_core/Message';
import { fetchMyFavorites } from 'redux/actions';

const FavoritesFetcher = (
    {
        children
    }
) => {
    const dispatch = useDispatch();
    const fetched = useSelector(state => state.user.myFavorites.fetched);
    const error = useSelector(state => state.user.myFavorites.error);

    useEffect(() => {
        dispatch(fetchMyFavorites());
    }, [dispatch])

    if (error) {
        return (
            <Message heading="Error loading courses" error noIcon small>
                Refresh the page to try again.
            </Message>
        );
    }

    if (!fetched) {
        return <InlineLoader />;
    }

    return children;
};

export default FavoritesFetcher;
